import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';

function GalleryItem({info}) {
    const navigate = useNavigate();
    const params = useParams();
    const slug = params['*'];

    const props = info?.extra?.props || {};
    const columns = info?.template?.columns || [];
    const gridColsClass = `cols-${Math.min(columns.length, 3)}`;

    const renderProperty = (prop) => {
        const name = prop.name;
        const value = props[name];
        if (value == null || value === "") return null;

        const label = prop.show_name ? (
            <div style={{ fontSize: '0.85rem', color: '#777', marginBottom: '4px', textAlign: 'center' }}>{name}</div>
        ) : null;

        if (prop.type === 'image') {
            return (
                <div key={name} style={{ marginBottom: '16px', textAlign: 'center' }}>
                    {label}
                    <img src={value} alt={name} style={{ maxWidth: '100%', borderRadius: '8px', display: 'block', margin: '0 auto' }} />
                </div>
            );
        }

        if (prop.type === 'line') {
            const fontSize = prop.meta.fontSize === 'heading' ? '2rem' : prop.meta.fontSize === 'sub-heading' ? '1.5rem' : '1rem';
            return (
                <div key={name} style={{ marginBottom: '16px', textAlign: 'center' }}>
                    {label}
                    <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5, fontSize }}>{prop.meta.prefix} {value} {prop.meta.suffix}</div>
                </div>
            );
        }

        if (prop.type === 'text') {
            return (
                <div key={name} style={{ marginBottom: '16px', textAlign: 'center' }}>
                    {label}
                    <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{value}</div>
                </div>
            );
        }

        // default: 'line' or other simple types
        return (
            <div key={name} style={{ marginBottom: '12px', textAlign: 'center' }}>
                {label}
                <div>{value}</div>
            </div>
        );
    };

    const content = info.body || info.extra?.body || '';

    return (
        <div className="justify" style={{ width: '100%' }}>
            <div className="justify">
                {typeof content === "string" ? parse(content) : null}
            </div>

            {columns.length > 0 && (
                <div className={`template-grid ${gridColsClass}`} style={{ width: '100%' }}>
                    {columns.map((col, cIdx) => (
                        <div key={cIdx} className="template-col">
                            {(col.properties || []).map(renderProperty)}
                        </div>
                    ))}
                </div>
            )}

            <button
                className="btn-back"
                onClick={() => navigate(`/${slug.split('/').slice(0, -1).join('/')}`)}
            >
                Go Back
            </button>
        </div>
    );
}

export default GalleryItem;